/** P9-UI rehype plugin: GFM renders `[^1][^3][^7]` as three directly adjacent `<sup>` links, which read as
 * "137". A `<sup>,</sup>` goes between two footnote references with nothing in between (text in between,
 * even a space, keeps them apart already). */
interface HastNode {
  type: string;
  tagName?: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
}

const isFootnoteRef = (n: HastNode | undefined): boolean =>
  n?.type === "element" &&
  n.tagName === "sup" &&
  (n.children ?? []).some((c) => c.type === "element" && c.tagName === "a" && !!c.properties?.dataFootnoteRef);

export function separateFootnoteRefs(node: HastNode): void {
  const kids = node.children;
  if (!kids) return;
  for (let i = kids.length - 1; i > 0; i--) {
    if (isFootnoteRef(kids[i]) && isFootnoteRef(kids[i - 1])) {
      kids.splice(i, 0, { type: "element", tagName: "sup", properties: {}, children: [{ type: "text", value: "," } as HastNode] });
    }
  }
  kids.forEach(separateFootnoteRefs);
}

export default function rehypeFootnoteSeparators() {
  return (tree: HastNode) => separateFootnoteRefs(tree);
}
